import { defineMessages } from 'react-intl';

export default defineMessages({
  saveChangesLabel: {
    id: 'PaymentMethodsStep.payment.saveChangesLabel',
    defaultMessage: 'Save changes',
  },
  saveButton: {
    id: 'PaymentMethodsStep.payment.save.title',
    defaultMessage: 'Save and Review Order',
  },
  errorTitle: {
    id: 'PaymentMethodsStep.payment.error.title',
    defaultMessage: 'Payment Error',
  },
  discountCardErrorTitle: {
    id: 'PaymentMethodsStep.payment.discountCardError.discountCardErrorTitle',
    defaultMessage: 'Discover Card is not accepted',
  },
  discountCardErrorText1: {
    id: 'PaymentMethodsStep.payment.discountCardError.Text1',
    defaultMessage:
      'We’re sorry, we currently don’t accept Discover Card as a payment method on our website. Please',
  },
  discountCardErrorText2: {
    id: 'PaymentMethodsStep.payment.discountCardError.Text2',
    defaultMessage: 'to place your order or use a different payment method.',
  },
  callUsLinkText: {
    id: 'PaymentMethodsStep.payment.discountCardError.callUsLinkText',
    defaultMessage: 'call us: 888-848-0965',
  },
  chatNowLinkText: {
    id: 'PaymentMethodsStep.payment.discountCardError.chatNowLinkText',
    defaultMessage: 'chat now',
  },
  or: {
    id: 'PaymentMethodsStep.payment.discountCardError.or',
    defaultMessage: 'or',
  },
  privacyText: {
    id: 'PaymentMethodsStep.payment.privacyText',
    description: 'Privancy Policy details',
    defaultMessage:
      'By submitting your order, you confirm you are 18 years of age and agree to our',
  },
  termsOfUse: {
    id: 'PaymentMethodsStep.payment.termsOfUse',
    description: 'privacy policy terms of use',
    defaultMessage: 'terms of use',
  },
  privacyPlicyText: {
    id: 'PaymentMethodsStep.payment.privacyPlicyText',
    description: 'privacy policy',
    defaultMessage: 'privacy policy',
  },
  privacyConnector: {
    id: 'PaymentMethodsStep.payment.privacyConnector',
    description: 'privacy policy text connector',
    defaultMessage: 'and',
  },
  processingPayment: {
    id: 'PaymentMethodsStep.payment.processingPayment',
    description: 'processing payment',
    defaultMessage: 'Processing payment...',
  },
  loadingCustomPayment: {
    id: 'PaymentMethodsStep.payment.loadingCustomPayment',
    description: 'loading custom payment',
    defaultMessage: 'Loading {paymentMethod}...',
  },
  subtitle: {
    id: 'PaymentMethodsStep.payment.subtitle',
    description: 'Payment Form subtitle',
    defaultMessage: 'All transactions are secure and encrypted',
  },
});
